import React from 'react';
import { LinkButton } from '../../ui/LinkButton/LinkButton';
import type { ReliabilityNoticeLinkProps } from './types';

// The linked words of a notice sentence. Without a portal host to open there is nowhere to go, so the
// words stay plain text rather than becoming a link that does nothing.
export const ReliabilityNoticeLink: React.FC<ReliabilityNoticeLinkProps> = ({ children, onClick, testId }) =>
    onClick ? (
        <LinkButton variant="navigation" weight="medium" onClick={onClick} data-testid={testId}>
            {children}
        </LinkButton>
    ) : (
        <>{children}</>
    );
